export default __webpack_public_path__ + "static/media/Terrorist_Screening_Center.568b096d.png";